<template>
    <div>
        <b-skeleton-wrapper :loading="loading">
            <template #loading>
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
            </template>
            <div id="graph-container"
                 @mousedown="startDragging"
                 @mousemove="drag"
                 @mouseup="stopDragging"
                 @mouseleave="stopDragging">
                <vue-mermaid-string v-if="onComplate" :value="diagram" @node-click="nodeClick" />
            </div>
        </b-skeleton-wrapper>
        
        <!-- 슬라이더 UI 추가 -->
        <input type="range" min="1" max="200" v-model="scale" @input="updateScale" />
    </div>
</template>

<script>
import VueMermaidString from 'vue-mermaid-string'
import hal from 'hateoas-hal-link-resolver'

export default {
    props: {
        scenario: {
            type: Object
        }
    },
    components: {
        VueMermaidString,
    },

    async beforeMount() {
        await this.drawFlows()
        this.onComplate = true;
    },
    created() {
        this.loading = true;
    },
    mounted() {
        // const container = this.$el.querySelector('#graph-container');
        // container.addEventListener('wheel', this.zoom, { passive: false });
    },
    beforeDestroy() {
        const container = this.$el.querySelector('#graph-container');
        container.removeEventListener('wheel', this.zoom);
    },
    data() {
        return {
            item: '',
            onComplate: false,
            loading: false,
            dummyIdMap: [],
            cipherKey: 'flowId_cipher',
            clickingNodeId: null, // 클릭 상태를 추적할 변수 추가
            scale: 100, // 그래프 스케일을 나타내는 변수 추가 (초기값 100%)
            isDragging: false, // 드래그 상태 추적
            dragStartX: 0,
            dragStartY: 0,
            scrollLeft: 0,
            scrollTop: 0
        };
    },
    methods: {
        updateScale(event) {
            const svgElement = this.$el.querySelector('#graph-container svg');
            const scaleValue = event.target.value / 100;
            svgElement.style.transform = `scale(${scaleValue})`;
            svgElement.style.transformOrigin = 'top left';
        },
        startDragging(event) {
            this.isDragging = true;
            this.dragStartX = event.clientX;
            this.dragStartY = event.clientY;
            this.scrollLeft = this.$el.querySelector('#graph-container').scrollLeft;
            this.scrollTop = this.$el.querySelector('#graph-container').scrollTop;
            this.$el.querySelector('#graph-container').classList.add('dragging');
        },
        drag(event) {
            if (!this.isDragging) return;
            const x = event.clientX - this.dragStartX;
            const y = event.clientY - this.dragStartY;
            this.$el.querySelector('#graph-container').scrollLeft = this.scrollLeft - x;
            this.$el.querySelector('#graph-container').scrollTop = this.scrollTop - y;
        },
        stopDragging() {
            this.isDragging = false;
            this.$el.querySelector('#graph-container').classList.remove('dragging');
        },
        zoom(event) {
            event.preventDefault();
            const delta = event.deltaY > 0 ? -10 : 10;
            this.scale = Math.min(Math.max(this.scale + delta, 10), 200); // 스케일 범위 제한
            this.updateScale({ target: { value: this.scale } });
        },
        async drawFlows() {
            let hasCompleted = false;
            const orgId = this.extractId(this.scenario.organization);

            console.log(JSON.stringify(this.scenario.scenarioEvents));
            const ____dddd = await this.scenario.scenarioEvents.map(async flow => {
                const array = [];
                hasCompleted = flow.hasCompleted;
                const id = this.extractId(flow);
                const name = `"${flow.label}"`;
                const data = `${id}(${name})`;

                if (flow.outputs.length === 0) {
                    console.log(`No outputs for flow ${id}`);
                    const crc_id = this.getDummyId(flow.id);
                    this.dummyIdMap.push(crc_id);
                    array.push(`${data}-->${crc_id}((${name}))`);
                    array.push(`click ${crc_id}`);
                } else {
                    for (const v of flow.outputs) {
                        const _link = hal(v, 'linksTo');
                        if (_link) {
                            try {
                                const res = await this.$http.get(_link);
                                if (orgId == res.data.organizationId) {
                                    const _id = this.extractId(res.data);
                                    const _name = res.data.label;
                                    const _data = `${_id}("${_name}")`;
                                    array.push(`${data}-- "${v.facilityName}" -->${_data}`);
                                    array.push(`click ${_id}`);
                                }
                            } catch (error) {
                                console.error(`Failed to get link data for ${_link}:`, error);
                            }
                        } else if (!flow.hasCompleted) {
                            const crc_id = this.getDummyId(flow.id);
                            this.dummyIdMap.push(crc_id);
                            array.push(`${data}-->${crc_id}((${name}))`);
                            array.push(`click ${crc_id}`);
                        }
                    }
                }
                console.log(flow)
                if (flow.inputs && flow.inputs.length > 0) {
                    
                    for (const v of flow.inputs) {
                        const _link = hal(v, 'linksTo');
                        if (!_link && !flow.hasCompleted) {
                            array.push(`${this.getDummyId()}((${name}))-->${data}`);
                            array.push(`click ${data}`);
                        }
                    }
                } else {
                    console.log(`No inputs for flow ${id}`);
                }
                return array;
            });

            let flows2D = await Promise.all(____dddd);
            const flows = flows2D.reduce((acc, cur) => acc.concat(cur), []);

            if (this.scenario.scenarioEvents) {
                flows.push(`click ${this.extractId(this.scenario.scenarioEvents[0])}`);
            }

            this.dummyIdMap.forEach(element => {
                flows.push(`style ${element} ${this.getCycleStyle()};`);
            });

            this.item = [...new Set(flows)];
        }
        ,
        
        cipher(salt){
            const textToChars = text => text.split('').map(c => c.charCodeAt(0));
            const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
            const applySaltToChar = code => textToChars(salt).reduce((a,b) => a ^ b, code);

            return text => text.split('')
            .map(textToChars)
            .map(applySaltToChar)
            .map(byteHex)
            .join('');
        },
        decipher(salt){
            const textToChars = text => text.split('').map(c => c.charCodeAt(0));
            const applySaltToChar = code => textToChars(salt).reduce((a,b) => a ^ b, code);
            return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
        },
        getDummyId(id) {
            const myCipher = this.cipher(this.cipherKey);
            return '_' + myCipher(id + '');
        },
        getCycleStyle() {
            return 'fill:#bbf,stroke:#f66,stroke-width:3px,color:#fff,stroke-dasharray: 5 5'
        },
        async nodeClick(nodeId) {

            console.log('nodeId', nodeId)
            this.clickingNodeId = nodeId; // 클릭한 노드의 ID 저장
            //등록안된 시나리오.. 즉 보라색을 클릭했을때
            if(nodeId.startsWith('_')) {
                const _decipher = this.decipher(this.cipherKey);
                const id = _decipher(nodeId.substr(1));
                this.scenario.dummyNodeClickId = id;
            }

            const flow = this.scenario.scenarioEvents.find(f => nodeId == this.extractId(f))
            // cons
            if(flow && !flow.inputs) {
                const response = await this.$http.get(hal(flow, 'inputs'));
                flow.inputs = this.$hateaos(response).scenarioInProducts;
            }
            this.$emit('showChartDetail', flow);
        },
        extractId(flow) {
            if(flow) {
                const url = hal(flow, 'self');
                const id = url.split('/').pop();
                return id;
            }else {
                return null
            }

        },
        clearLoadingTimeInterval() {
            clearInterval(this.$_loadingTimeInterval)
            this.$_loadingTimeInterval = null
        },
    },
    computed: {
        // equals graph TD\n  A --> B
        diagram() {        
            // console.log(this.item)   
            let datas = this.item.join('\n');
            if (this.clickingNodeId) {
                datas += `\nstyle ${this.clickingNodeId} fill:yellow,stroke:red,stroke-width:3px;`;
            }
            // console.log(datas)

            this.scenario.scenarioEvents.forEach(sevent => {
                if(!datas.includes(`click ${sevent.id}`)) {
                    datas += `\nclick ${sevent.id}`
                }
            });

            return 'flowchart LR \n ' + datas;
        }
    },
    watch: {
        loading(newValue, oldValue) {
            // console.log('---->>>>>')
            if (newValue !== oldValue) {
                const me = this;
                this.clearLoadingTimeInterval()
                if (newValue) {
                    this.$_loadingTimeInterval = setInterval(() => {
                        me.loading = false;
                    }, 1000)
                }
            }
        },
    } 
};
</script>


<style scoped>
.cssClass>rect {
    fill: #bbf;
    stroke: #f66;
    stroke-width: 1px;
    color: #fff;
    stroke-dasharray: 5 5
}
#graph-container {
    overflow: auto; /* 스크롤바를 위한 overflow 설정 */
    width: 100%;
    height: 100%;
    position: relative;
    max-width: 100vw; /* 화면 크기를 넘지 않도록 설정 */
    max-height: 100vh; /* 화면 높이를 넘지 않도록 설정 */
    cursor: grab; /* 기본 커서 설정 */
}

#graph-container.dragging {
    cursor: grabbing; /* 드래그 중일 때 커서 설정 */
}

svg {
    transition: transform 0.2s ease;
}
</style>